import { render, staticRenderFns } from "./inputPrice.vue?vue&type=template&id=2dc1bc10&scoped=true"
import script from "./inputPrice.vue?vue&type=script&lang=js"
export * from "./inputPrice.vue?vue&type=script&lang=js"
import style0 from "./inputPrice.vue?vue&type=style&index=0&id=2dc1bc10&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dc1bc10",
  null
  
)

export default component.exports